import {getResource} from "./common"
import {AuditLogEventChanges} from "../components/AuditLogEventsView/AuditLogEventsView"

export type AuditLogResource =
	| "deposit-product"
	| "customer"
	| "account"
	| "application"
	| "beneficialOwner"
	| "wallet-terms"

type AuditLogAttributes = {
	createdAt: string
	actorUserId: string
	actorUserRole: string
	actorUserType: string
	actorUserName: string
	actorBankId?: string
	actorOrgId?: string
	resourceType: AuditLogResource
	resourceId: string
	intent: string
	changes?: AuditLogEventChanges[]
	actionTimestamp: string
}

export type AuditLog = {
	type: string
	id: string
	attributes: AuditLogAttributes
	relationships: {
		banks: {
			data: [
				{
					type: string
					id: string
				}
			]
		}
		org: {
			data: {
				type: string
				id: string
			}
		}
	}
}

export async function findApplicationAuditLogs(accessToken: string, offset: number, limit: number, resourceId: string) {
	const query = {
		page: {
			limit,
			offset,
		},
	}
	return await getResource<Array<AuditLog>>(`applications/${resourceId}/audit-log`, accessToken, query)
}

export async function findAuditLogs(
	accessToken: string,
	offset: number,
	limit: number,
	resourceIds: string[],
	resourceTypes: AuditLogResource[]
) {
	const query = {
		page: {
			limit,
			offset,
		},
		filter: {
			resourceIds: resourceIds,
			resourceTypes: resourceTypes,
		},
	}

	return await getResource<Array<AuditLog>>("audit-log", accessToken, query)
}

export const enrichIntentWithSubResourceId = (
	auditLogs: AuditLog[],
	showSubResourcesId: boolean,
	resourceType: AuditLogResource
) => {
	if (!showSubResourcesId) {
		return auditLogs
	}
	return auditLogs.map((auditLog) => {
		if (resourceType !== auditLog.attributes.resourceType) {
			const intent = auditLog.attributes.intent
			const resourceId = auditLog.attributes.resourceId
			const resourceType = auditLog.attributes.resourceType
			return {
				...auditLog,
				attributes: {
					...auditLog.attributes,
					intent: `${intent} (${resourceType} Id ${resourceId})`,
				},
			}
		} else {
			return auditLog
		}
	})
}
